import * as React from 'react';

import { BillApi } from '@ClientApi/billApi';
import { StripeActivationPlanPricingDetails } from '@Shared/interfaces/BillingTypes';

/**
 * Fetches activation plan pricing details from the Stripe pricing API.
 * Returns the pricing data and a loading flag.
 */
export function useActivationPlanPricing(billingPlan?: string | null) {
  const [pricingDetails, setPricingDetails] = React.useState<StripeActivationPlanPricingDetails | null>(null);
  const [pricingLoading, setPricingLoading] = React.useState(true);

  React.useEffect(() => {
    async function fetchPricingDetails() {
      if (!billingPlan) {
        setPricingDetails(null);
        setPricingLoading(false);
        return;
      }
      setPricingLoading(true);
      try {
        const details = await BillApi.getActivationPlanPricingDetails(billingPlan);
        setPricingDetails(details);
      } catch {
        setPricingDetails(null);
      } finally {
        setPricingLoading(false);
      }
    }

    fetchPricingDetails();
  }, [billingPlan]);

  return { pricingDetails, pricingLoading };
}
